export default __webpack_public_path__ + "static/media/Heater-6.faf5d12a.mp3";